export const Url = "https://api.scab.ir/api/v2";
export const Url2 = "https://api.scab.ir/api/v1";
